interface state extends types.redux.rootReducer {}

export const appConfigSelector = ({ settings }: state) => settings.appConfig.config;
export const domainSelector = ({ settings }: state) => settings.appConfig.domain;
